module.exports = ".site-layout > div {\n  margin: 5px; }\n"